import { render, staticRenderFns } from "./colorSel.vue?vue&type=template&id=46f6ec5e&scoped=true&"
import script from "./colorSel.vue?vue&type=script&lang=js&"
export * from "./colorSel.vue?vue&type=script&lang=js&"
import style0 from "./colorSel.vue?vue&type=style&index=0&id=46f6ec5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f6ec5e",
  null
  
)

export default component.exports